export const MEDIA_HUB_SET_OPTIONS = 'MEDIA-HUB/SET_OPTIONS';
export const SET_CHECKBOX = 'MEDIA-HUB/SET_CHECKBOX';
export const TOGGLE_INFO = 'MEDIA-HUB/TOGGLE_INFO';
export const TOGGLE_FOLDERS = 'MEDIA-HUB/TOOGLE_FOLDERS';
export const SET_NAME = 'MEDIA-HUB/SET_NAME';
export const SET_DESCRIPTION = 'MEDIA-HUB/SET_DESCRIPTION';
export const TOGGLE_BIO = 'MEDIA-HUB/TOOGLE_BIO';

export const AvailableOptions = {
  TITLE: 'title',
  SHOW_SEARCH: 'showSearch',
  SHOW_ADD_NEW: 'showAddNew',
  DIRECTORIES: 'directories',
  PRESENTATION_TITLE: 'presentationTitle',
  SHOW_EDIT: 'showEdit',
  SHOW_DETAILS: 'showDetails',
  SHOW_DELETE: 'showDelete',
};

const initialState = {
  [AvailableOptions.TITLE]: '',
  [AvailableOptions.SHOW_SEARCH]: false,
  [AvailableOptions.SHOW_ADD_NEW]: false,
  [AvailableOptions.DIRECTORIES]: [],
  [AvailableOptions.PRESENTATION_TITLE]: '',
  [AvailableOptions.SHOW_EDIT]: false,
  [AvailableOptions.SHOW_DETAILS]: false,
  [AvailableOptions.SHOW_DELETE]: false,
  selected: [],
  extensions: false,
  toggleInfo: false,
  toggleBio: false,
  toggleFolders: false,
  name: '',
  description: '',
};

export const setOptions = options => ({
  type: MEDIA_HUB_SET_OPTIONS,
  payload: options,
});

export const setCheckbox = ({ id }) => ({
  type: SET_CHECKBOX,
  payload: id,
});

export const setName = ({ name }) => ({
  type: SET_NAME,
  payload: name,
});

export const setDescription = ({ description }) => ({
  type: SET_DESCRIPTION,
  payload: description,
});

export const toggleInfo = () => ({
  type: TOGGLE_INFO,
});

export const toggleBio = () => ({
  type: TOGGLE_BIO,
});

export const toggleFolders = () => ({
  type: TOGGLE_FOLDERS,
});

export const mediaHubReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MEDIA_HUB_SET_OPTIONS: {
      return {
        ...initialState,
        ...payload,
      };
    }
    case SET_NAME: {
      return {
        ...state,
        name: payload,
      };
    }
    case SET_DESCRIPTION: {
      return {
        ...state,
        description: payload,
      };
    }
    case SET_CHECKBOX: {
      return {
        ...state,
        selected: state.selected.includes(payload)
          ? state.selected.filter(id => id !== payload)
          : [...state.selected, payload],
      };
    }
    case TOGGLE_INFO: {
      return {
        ...state,
        toggleInfo: !state.toggleInfo,
      };
    }
    case TOGGLE_BIO: {
      return {
        ...state,
        toggleBio: !state.toggleBio,
      };
    }
    case TOGGLE_FOLDERS: {
      return {
        ...state,
        toggleFolders: !state.toggleFolders,
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mediaHub.reducer.js